import React, { useEffect, useState } from "react";
import styled from "styled-components";
import * as Sentry from "@sentry/react";
import Pagination from "../../components/parts/Pagination";
import { GetAdministratorsUsers200ResponseInner } from "../../../api/v1";
import { api } from "../../../api";
import AdministratorLayout from "../../components/layouts/AdministratorLayout";
import AdministratorUserList from "../../components/combinations/Administrator/AdministratorUserList";
import { useLocation, useNavigate } from "react-router-dom";

const ShopsStyle = styled.div`
  background: white;
  border-radius: 25px;
  padding: 20px 0;
  margin: 30px;

  @media (max-width: 767px) {
    margin: 30px 10px;
  }
`;

const OverviewStyle = styled.div`
  margin: 0 30px 10px 30px;

  @media (max-width: 767px) {
    margin: 0 12px 10px 12px;
  }

  h2 {
    color: #383432;
    display: inline-block;
    font-size: 18px;
    font-weight: bold;
    margin: 0 10px 0 0;
  }

  p {
    display: inline-block;
    font-size: 10px;
    margin: 0;
  }

  span {
    font-size: 34px;
  }
`;

const Users: React.FC = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const page = Number(searchParams.get("page")) || 1;
  const [users, setUsers] = useState<
    Array<GetAdministratorsUsers200ResponseInner>
  >([]);
  const [currentPageNumber, setCurrentPageNumber] = useState<number>();
  const [pageNumbers, setPageNumbers] = useState<Array<number>>([]);
  const [totalCount, setTotalCount] = useState<string>();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    api
      .getAdministratorsUsers(page)
      .then((response) => {
        setUsers(response.data);
        setCurrentPageNumber(Number(response.headers["x-current-page"]));
        setTotalCount(response.headers["x-total-count"] || 0);
        const totalPages = Number(response.headers["x-total-pages"]) || 0;
        const pageList = [...Array(totalPages)].map((_, i) => i + 1);
        setPageNumbers(pageList);
      })
      .catch((error) => {
        if (error.response?.status === 401) navigate("/administrator/login");
        Sentry.captureException(error);
      });
  }, [location.search]);

  return (
    <AdministratorLayout>
      <ShopsStyle>
        <OverviewStyle>
          <h2>件数</h2>
          <p>
            <span>{totalCount}</span>件
          </p>
        </OverviewStyle>
        <AdministratorUserList users={users} />
        <Pagination
          numbers={[
            // NOTE:  pageNumbersが1始まりなため配列の真ん中がcurrentPageNumberと一致するように調整
            pageNumbers[currentPageNumber - 3],
            pageNumbers[currentPageNumber - 2],
            pageNumbers[currentPageNumber - 1],
            pageNumbers[currentPageNumber],
            pageNumbers[currentPageNumber + 1],
          ]}
          currentPageNumber={currentPageNumber}
          url={window.location.origin + window.location.pathname}
        />
      </ShopsStyle>
    </AdministratorLayout>
  );
};
export default Users;
